/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Create_LabelInputs */



/**
* | output |
* | --- |
* | "Create new API key" |
*
* @param {Options_Api_Keys_Create_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_create_label = /** @type {((inputs?: Options_Api_Keys_Create_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Create_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer une nouvelle clé API")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuen API-Schlüssel erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea una nuova chiave API")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать новый ключ API")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear nueva clave API")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新的 API 密钥")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいAPIキーを作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई एपीआई कुंजी बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar nova chave de API")
	return /** @type {LocalizedString} */ ("Create new API key")
});